export const COLORS = {
  light: {
    backgroundDefault: "#F8FAFC",
    backgroundPaper: "#ffffff",
    primaryMain: "#3291CA",
    primaryContrastText: "#0f0d0dff",
    textPrimary: "#0F172A",
    textSecondary: "#15eb60ff",
    containerMain: "#F1F5F9",
    cerebralGrey: "#ccc",
    splishSplash: "#3291ca66",
    alienated: "#15eb60ff",
    errorMain: "#d32f2f",
    errorDark: "#9a0007",
    divider: "#e0e0e0",
    grey400: "#bdbdbd",
    grey500: "#9e9e9e",
    grey600: "#757575",
    successMain: "#15eb60ff",
    successDark: "#308345ff",
    warningMain: "#ff9800",
    infoMain: "#2196f3",
    actionHover: "#f5f5f5",
    border: "#ccc",
    white: "#FFFFFF",
    black: "#000000",
    transparent: "transparent",
    archiveRed: "#4e1f1fff",
    oliveGreen: "#496550ff",
    // Header colors
    headerBackground: "#22253b",
    headerText: "#ffffff",
    headerLogoHover: "#f0f0f0",
    headerMenuButton: "#ffffff",
    // Login specific colors
    loginBackground: "#303950",
    loginBorderGradient: "linear-gradient(135deg, #91A1B9, #41485300)",
    loginInputBorder: "#3e4a66",
    loginResendOtp: "#7AAEFF",
    loginButton: "#0E900F",
    loginError: "#ff4d4f",
  },
  dark: {
    backgroundDefault: "#0F172A",
    backgroundPaper: "#353E52",
    primaryMain: "#38BDF8",
    primaryContrastText: "#FFFFFF",
    textPrimary: "#FFFFFF",
    textSecondary: "#15eb60ff",
    containerMain: "#1E293B",
    cerebralGrey: "#b4bab6ff",
    splishSplash: "#3687ba66",
    alienated: "#15eb60ff",
    errorMain: "#d32f2f",
    errorDark: "#9a0007",
    divider: "#424242",
    grey400: "#bdbdbd",
    grey500: "#9e9e9e",
    grey600: "#757575",
    successMain: "#15eb60ff",
    successDark: "#308345ff",
    warningMain: "#ff9800",
    infoMain: "#2196f3",
    actionHover: "#353E52",
    border: "#b4bab6ff",
    white: "#FFFFFF",
    black: "#000000",
    transparent: "transparent",
    archiveRed: "#4e1f1fff",
    oliveGreen: "#496550ff",
    // Header colors
    headerBackground: "#22253b",
    headerText: "#ffffff",
    headerLogoHover: "#f0f0f0",
    headerMenuButton: "#ffffff",
    // Login specific colors
    loginBackground: "#303950",
    loginBorderGradient: "linear-gradient(135deg, #91A1B9, #41485300)",
    loginInputBorder: "#3e4a66",
    loginResendOtp: "#7AAEFF",
    loginButton: "#0E900F",
    loginError: "#ff4d4f",
  },
};

export const SplishSplash = COLORS.light.splishSplash;
export const Alienated = COLORS.light.alienated;
export const CerebralGrey = COLORS.light.cerebralGrey;
export const White = COLORS.light.white;
export const HeaderBackground = COLORS.light.headerBackground;
export const HeaderText = COLORS.light.headerText;
